/* eslint react-hooks/exhaustive-deps: "warn" */

import Image from 'next/image';

import { useInt } from 'hooks/useInt';

import styles from './RegistryWall.module.scss';

const REGISTRIES: [string, string][] = [
  ['GB', 'Companies House'],
  ['US', 'SEC EDGAR'],
  ['DE', 'Handelsregister'],
  ['FR', 'Infogreffe / RCS'],
  ['IT', 'Registro Imprese'],
  ['ES', 'Registro Mercantil'],
  ['NL', 'KVK Handelsregister'],
  ['BE', 'Kruispuntbank / BCE'],
  ['SE', 'Bolagsverket'],
  ['NO', 'Brønnøysundregistrene'],
  ['DK', 'Erhvervsstyrelsen'],
  ['FI', 'PRH'],
  ['AT', 'Firmenbuch'],
  ['CH', 'Zefix'],
  ['IE', 'Companies Reg. Office'],
  ['PT', 'Registo Comercial'],
  ['PL', 'Krajowy Rejestr Sądowy'],
  ['CZ', 'Obchodní rejstřík'],
  ['HU', 'Cégjegyzék'],
  ['RO', 'ONRC'],
  ['MD', 'Agenția Servicii Publice'],
  ['AU', 'ASIC'],
  ['NZ', 'NZ Companies Office'],
  ['SG', 'ACRA'],
  ['HK', 'Companies Registry'],
  ['IN', 'MCA21'],
  ['JP', 'National Tax Agency'],
  ['KR', 'DART'],
  ['MY', 'SSM'],
  ['AE', 'Dept. of Economic Dev.'],
  ['ZA', 'CIPC'],
  ['CA', 'Corporations Canada'],
  ['MX', 'Registro Público'],
  ['BR', 'Receita Federal / CNPJ'],
  ['AR', 'Inspección General'],
  ['CL', 'Registro de Empresas'],
  ['GR', 'GEMI'],
  ['BG', 'Targovski Registar'],
  ['HR', 'Sudski registar'],
  ['NG', 'Corporate Affairs Comm.'],
  ['KE', 'Business Reg. Service'],
];

const HOT = new Set(['Companies House', 'SEC EDGAR', 'ACRA', 'Agenția Servicii Publice']);

const half = Math.ceil(REGISTRIES.length / 2);
const colA = REGISTRIES.slice(0, half);
const colB = REGISTRIES.slice(half);

interface RegistryItemProps {
  cc: string;
  name: string;
}

const RegistryItem = ({ cc, name }: RegistryItemProps) => (
  <div className={`${styles.reg}${HOT.has(name) ? ` ${styles.regHot}` : ''}`}>
    <Image
      className={styles.flag}
      src={`/storage/flags/${cc.toLowerCase()}.svg`}
      alt={cc}
      width={22}
      height={16}
      unoptimized
    />
    <span className={styles.name}>{name}</span>
    <span className={styles.code}>{cc}</span>
  </div>
);

const Track = ({ items, direction }: { items: [string, string][]; direction: 'up' | 'down' }) => (
  <div className={styles.track}>
    <div className={`${styles.trackInner} ${direction === 'up' ? styles.trackUp : styles.trackDown}`}>
      {[...items, ...items].map(([cc, name], i) => (
        <RegistryItem key={`${cc}-${name}-${i}`} cc={cc} name={name} />
      ))}
    </div>
  </div>
);

export const RegistryWall = () => {
  const { t } = useInt();

  return (
    <div className={styles.wall}>
      <div className={styles.bar}>
        <span className={styles.barTitle}>{t('Registry network')}</span>
        <span className={styles.live}>
          <i className={styles.dot} />
          400+ connected
        </span>
      </div>
      <div className={styles.cols}>
        <Track items={colA} direction="up" />
        <Track items={colB} direction="down" />
      </div>
    </div>
  );
};
